const config = {
    levels: ['info', 'log', 'warn', 'error'],
    current: 'log'
}
export default config